<script lang="ts">
    import { onMount, createEventDispatcher } from "svelte";
    import { serpPageConfigStores } from "../../../stores/stores.serpPage";
    import { FilterStores } from "../../../../types/types.serpPage";
    import { Icon } from "../../../../generic/components";
    import { ParametersFilterResponse } from "../../../../types/types.serpPage";

    export let filter: FilterStores;

    let show: boolean = false;
    let isClosed: boolean = false;
    let isEmpty: boolean = false;
    let prices: number[] = [];
    const dispatch = createEventDispatcher();

    onMount(() => {
        isClosed = $serpPageConfigStores.isFilterCloseOnStart ?? false;
        isEmpty = filter.currentValueSelected?.length == 0;
        if (isEmpty) {
            show = !isClosed && !isEmpty;
        }
    });

    function toogleCollapse() {
        show = !show;
    }

    function generateSelectetPricesRange(selectedDictionaryId: string) {
        if (filter.dictionary) {
            filter.dictionary.find((item) => {
                if (item.id === selectedDictionaryId) {
                    prices = [parseFloat(item.priceFrom), parseFloat(item.priceTo)];
                }
            });
        }
    }

    function valueChanged(selectedDictionaryId: string) {
        generateSelectetPricesRange(selectedDictionaryId);
        dispatch("valueChanged", {
            value: prices,
            filter: filter,
        });
    }

    function checkIsChecked(currentValue: ParametersFilterResponse): boolean {
        const currentDictionarySelected = (filter.dictionary && filter.currentValueSelected && filter.currentValueSelected.length && filter.dictionary.length) ? filter.dictionary.find(item => (parseFloat(filter.currentValueSelected[0]) == parseFloat(item['priceFrom']) && parseFloat(filter.currentValueSelected[1]) == parseFloat(item['priceTo']))): null;
        return currentDictionarySelected != null && currentDictionarySelected.name === currentValue.name;
    }

    $: selectedValuesCount = filter?.currentValueSelected?.length ? 1 : 0;
</script>

<div class="dropdown">
    <button class="filter-btn" class:hasSelectedValues={selectedValuesCount > 0} class:collapsed={!show} on:click={toogleCollapse} type="button" data-bs-toggle="dropdown" aria-expanded="false" title="">
        {#if selectedValuesCount > 0}
            <span class="badge bg-ruby-chocolate text-primary">{selectedValuesCount}</span>
        {/if}
        <span class="flex-grow-1 text-start">{filter.name}</span>
        <Icon template="ic-chevron-down" width="0.75rem" height="0.75rem" styleClass="bsCollapseIcon" />
    </button>
    <ul class="filter-options dropdown-menu">
        {#each filter.currentValues as currentValue}
            <li class:filter-active={checkIsChecked(currentValue)}>
                <button class="filter-option-btn" type="button"  on:click={() => {valueChanged(currentValue?.value);}} title="">
                    {filter.getNameOfValue(currentValue.name)}
                </button>
            </li>
        {/each}
    </ul>
</div>
